import { makeUseIntl, makeUseMessage, makeUseMessages } from '@retailer-platform/shared-components'
import { type DashIntlShape, type DashMessages } from './intl.types'

export const useDashIntl = makeUseIntl<DashIntlShape>()
export const useDashMessage = makeUseMessage<DashMessages>()
export const useDashMessages = makeUseMessages<DashMessages>()
